<footer class="border-t border-hairline py-10">
  <div
    class="mx-auto flex max-w-6xl flex-col gap-5 px-6 text-sm text-dusk sm:flex-row sm:items-center sm:justify-between sm:px-10"
  >
    <span>Ghoul Pool is a production of Ghoulish Mortals — Saint Charles, IL.</span>
    <div class="flex gap-6">
      <a routerLink="/login" class="transition-colors hover:text-parchment">Log In</a>
      <a routerLink="/register" class="transition-colors hover:text-parchment">Sign Up</a>
      <a routerLink="/terms" class="transition-colors hover:text-parchment">Terms</a>
      <a routerLink="/privacy" class="transition-colors hover:text-parchment">Privacy</a>
    </div>
  </div>
</footer>
